import Vue from 'vue';
import App from './App.vue';

// router
import router from "./router";
// axios
import axios from "@assets/js/axios";
Vue.use(axios);

import Mint from "mint-ui";
Vue.use(Mint);
import "mint-ui/lib/style.css";

import 'vw-layout';

import '@assets/style/main.css';

// store
import store from '@store';

// 工具函数
import $tool from '@assets/js/tool';
Vue.prototype = Object.assign(Vue.prototype, $tool);

Vue.config.productionTip = false

const vm = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

export default vm;
